import React from 'react'

import { getFieldTypes } from '../../../pages'
import { FullFieldsMenu } from '../../full-fields-menu'

import { FieldsTypesProps } from '../popup-document-validation.types'

export const VerificationFields = ({
  className = '',
  isEditable,
  activeField,
  fieldType,
  fields,
  onApprove,
  onReject,
  onFocusInput,
  onBlurInput
}: FieldsTypesProps) => {
  const { isValidated } = getFieldTypes({
    fieldType
  })

  if (isValidated) {
    return null
  }

  const isFieldsExist = Boolean(fields.verification.length)
  if (!isFieldsExist) {
    return null
  }

  return (
    <FullFieldsMenu
      multiValue
      className={className}
      isEditable={isEditable}
      activeField={activeField}
      data={fields.verification}
      title="Fields for Verification"
      titleTx="fields.verification"
      onApprove={onApprove}
      onReject={onReject}
      onFocusInput={onFocusInput}
      onBlurInput={onBlurInput}
    />
  )
}
